<ce-tile-basic i18n-title="Tile usage header|@@" [title]="title" [hideOpenDialogBtn]="true" [loading]="loading">
    <ng-container tile-content>
        <!-- Life time energy output-->
        <div class="figure">
            <div i18n="Usage info text" class="label">Lifetime energy output</div>
            <div class="number" *ngIf="totalEnergykWh >= 0">{{ totalEnergykWh | number: '0.0-0' }} kWh</div>
        </div>

        <!-- Total kWh past 30 days -->
        <div class="figure">
            <div i18n="Usage info text" class="label">Energy output past 30 days</div>
            <div class="number" *ngIf="totalEnergykWhPast30days >= 0">
                {{ totalEnergykWhPast30days | number: '0.0-0' }} kWh
            </div>
        </div>

        <!-- Peak power today -->
        <div class="figure">
            <div i18n="Usage info text" class="label">Peak power past 30 days</div>
            <div class="number" *ngIf="peakPowerkW >= 0">{{ peakPowerkW | number: '0.1-1' }} kW</div>
        </div>
    </ng-container>

    <ng-container tile-footer>
        <!-- Usage heatmap-->
        <cal-heatmap
            *ngIf="calendarHeatmapData"
            [width]="230"
            [height]="63"
            [range]="calendarMonths"
            [timestamp]="calendarHeatmapDataStart"
            [data]="calendarHeatmapData"
            (dateClicked)="dateClicked($event)"
        >
        </cal-heatmap>
    </ng-container>
</ce-tile-basic>
